import { createSearchParams, useNavigate } from "react-router-dom";

const useNavigateSearch = () => {
    const navigate = useNavigate();
    return (pathname, params) =>{
      return navigate({ pathname, search: `?${createSearchParams(params)}` });
    }
  };
  
  export default useNavigateSearch;